import { Component, HostListener, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CompanyConstant } from 'src/app/constants/label-constants';
import { CompanyModel } from 'src/app/models/company-model';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { CompanyAddEditComponent } from './company-add-edit/company-add-edit.component';
import { CompanyViewComponent } from './company-view/company-view.component';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent {
  companyForm: FormGroup = this.formBuilder.group({});
  CompanyList: any = [];
  showData: boolean = false;
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'CompanyName', 'CompanyCode', 'EmailId', 'MobileNo', 'isActive', 'Action'];
  dataSource: MatTableDataSource<CompanyModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  companyStatusObj: any = {};
  companyDeleteObj: any = {};
  CommonConstant: any = [];
  NoRecordFound: any = [];
  CompanyConstant: any = [];
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.companyForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private router: Router,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.CompanyConstant = CompanyConstant;
    this.getCompanyList();
    this.sharedService.setData('Company');
  }

  getCompanyList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.company.GetCompanyList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.CompanyList = response.data;
          this.dataSource.data = this.CompanyList;
          if (this.CompanyList.length > 0) {
            TotalRecords = this.CompanyList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getCompanyList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getCompanyList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getCompanyList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getCompanyList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getCompanyList();
    this.searchClose = false;
  }

  onView(companyId: number) {
    var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', companyId);
    this.router.navigate(['company/view', encrypted]);
  }

  AddCompany(companyId: number) {
    const modalRef = this.modalService.open(CompanyAddEditComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.companyId = companyId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getCompanyList();
      }
    }).catch((error) => {
    });
  }

  CompanyListDetail(companyId: number) {
    const modalRef = this.modalService.open(CompanyViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.companyId = companyId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  Deletepopup(companyId: number, companyName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.companyDeleteObj = {
      companyId: companyId,
      companyName: companyName,
      element: 'company'
    }
    modalRef.componentInstance.companyDeleteObj = this.companyDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getCompanyList();
      }
    }).catch((error) => {
    });
  }

  onStatus(companyId: number, companyName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.companyStatusObj = {
      companyId: companyId,
      companyName: companyName,
      activecompany: active
    }
    modalRef.componentInstance.companyStatusObj = this.companyStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.CompanyList.forEach((element: { companyId: number; isActive: boolean; }) => {
          if (element.companyId == companyId) {
            element.isActive = active ? false : true
            this.getCompanyList()
          }
        });
      }
    }).catch((error) => {
    });
  }
}
